import React from "react";
import {
    Box,
    Typography,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";
import SlidePanel from "@/theme/partials/slidepanel";

// Hooks
import { useTranslation } from "@/hooks/useTranslation";

const UserEditPanel = ({ 
    isOpen, 
    onClose, 
    currentUser, 
    roles, 
    loading, 
    onRoleChange, 
    onSave, 
    onToggleStatus, 
    onDelete
}) => {
    const { t } = useTranslation();
    
    if (!currentUser) return null;

    return (
        <SlidePanel
            title={t('user.edit')}
            isOpen={isOpen}
            onClose={onClose}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        {currentUser.is_active === 1 ? (
                            <Box 
                                sx={{ 
                                    width: 10, 
                                    height: 10, 
                                    borderRadius: '50%', 
                                    bgcolor: '#f7cb45', 
                                    mr: 1.5,
                                    boxShadow: '0 0 4px rgba(247, 203, 69, 0.8)'
                                }} 
                            />
                        ) : (
                            <Box 
                                sx={{ 
                                    width: 10, 
                                    height: 10, 
                                    borderRadius: '50%', 
                                    bgcolor: '#9e9e9e', 
                                    mr: 1.5,
                                    boxShadow: '0 0 4px rgba(158, 158, 158, 0.8)'
                                }} 
                            />
                        )}
                        <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                            {currentUser.email}
                        </Typography>
                    </Box>
                </Box>
                
                <Box sx={{ mt: 2, mb: 2 }}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>{t('user.role')}</InputLabel>
                        <Select
                            value={currentUser.role_id}
                            onChange={onRoleChange}
                            label={t('user.role')}
                        >
                            {roles.map(role => (
                                <MenuItem key={role.id} value={role.id}>
                                    {role.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button 
                            variant="contained" 
                            color="primary"
                            onClick={onSave}
                            disabled={loading}
                            size="small"
                        >
                            {loading ? t('common.saving') : t('common.save')}
                        </Button>
                    </Box>
                </Box>
                
                <Divider sx={{ my: 2 }} />
                
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="subtitle1">
                        {t('common.dangerZone')}
                    </Typography>
                    
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={onToggleStatus}
                        startIcon={currentUser.is_active === 1 ? <Icon name="boltSlash" size={16} /> : <Icon name="checkmark" size={16} />}
                        sx={{ alignSelf: 'flex-start' }}
                    >
                        {currentUser.is_active === 1 ? t('user.deactivate') : t('user.activate')}
                    </Button>
                    
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => onDelete(currentUser.email)}
                        startIcon={<Icon name="delete" size={16} />}
                        sx={{ alignSelf: 'flex-start' }}
                    >
                        {t('user.delete')}
                    </Button>
                </Box>
            </Box>
        </SlidePanel>
    );
};

export default UserEditPanel;